import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function getAgentFormsByPolicy(policyNumber, agentId) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };
  let url =
    config.REG_API_BASE_URL +
    "/Forms?Portal=agent&PolicyId=" +
    policyNumber +
    (agentId ? "&UserId=" + encodeURIComponent(agentId) : "");

  const response = await fetch(url, options);
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
